import BaseItem, { Rarity } from './base_item';

export default class SpaceSuit extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "spacesuit.png");
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 15;}
    static get height() { return 8;}

    static get mass() { return 2;}
    static get electronic() { return false; }
    static get rarity() { return Rarity.RARE; }

    static get type() { return 'spacesuit'}

    static get label() { return 'space suit'}
    static get description() { return `A space suit. Suited for a space party.`}
}


// WEBPACK FOOTER //
// ./src/objects/items/space_suit.js